
import React from "react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { CalendarCheck, PlusCircle } from "lucide-react";

interface EmptyRecebimentosListProps {
  tipoLista: "pendentes" | "historico";
  onAgendar?: () => void;
}

const EmptyRecebimentosList: React.FC<EmptyRecebimentosListProps> = ({
  tipoLista,
  onAgendar
}) => {
  const isPendentes = tipoLista === "pendentes";
  
  return (
    <Card className="border-dashed border-2 p-6">
      <div className="text-center text-gray-500">
        <CalendarCheck className="h-12 w-12 mx-auto mb-3 opacity-30" />
        <p className="mb-2">
          {isPendentes ? "Nenhum recebimento pendente" : "Nenhum recebimento registrado"}
        </p>
        <p className="text-sm mb-4">
          {isPendentes 
            ? "Todos os seus recebimentos foram processados" 
            : "Registre seus recebimentos para visualizar o histórico"}
        </p>
        {isPendentes && onAgendar && (
          <Button 
            onClick={onAgendar}
            className="bg-financeiro-accent-DEFAULT hover:bg-financeiro-accent-dark"
          >
            <PlusCircle className="h-4 w-4 mr-2" /> Agendar Novo Recebimento
          </Button>
        )}
      </div>
    </Card>
  );
};

export default EmptyRecebimentosList;
